export const LEAD_BANNER_PLACEMENT = {
    SERP: 'serp',
    HOTEL_PAGE: 'hotel_page',
    TOUR_PAGE: 'tour_page',
} as const;

export type LeadBannerPlacement = typeof LEAD_BANNER_PLACEMENT[keyof typeof LEAD_BANNER_PLACEMENT];

export const LEAD_BANNER_TRIGGER_REASON = {
    DEFAULT: 'default',
    EMPTY_SERP: 'empty_serp',
    SHORT_SERP: 'short_serp',
    ALTERNATIVE_SERP: 'alternative_serp',
} as const;

export type LeadBannerTriggerReason =
    typeof LEAD_BANNER_TRIGGER_REASON[keyof typeof LEAD_BANNER_TRIGGER_REASON];

export const LEAD_BANNER_GOAL = {
    IMPRESSION: 'assistantSalesCardImpression',
    SHEET_OPEN: 'assistantSalesSheetOpen',
    FORM_START: 'assistantSalesFormStart',
    FORM_SUBMIT: 'assistantSalesFormSubmit',
} as const;

export interface LeadBannerCommonParams {
    placement: LeadBannerPlacement;
    card_id: string;
    trigger_reason: LeadBannerTriggerReason;
}

export interface LeadBannerImpressionParams extends LeadBannerCommonParams {
    position: number | null;
}

export interface LeadBannerSheetOpenParams extends LeadBannerCommonParams {
    position: number | null;
}

export type LeadBannerFormStartParams = LeadBannerCommonParams;
export type LeadBannerFormSubmitParams = LeadBannerCommonParams;
